<template>
    <div id="leftDiv1" class="panel panel-primary margin-bottom-15" v-show="billingSummaryLoaded && billingSummary !== ''">
        <div class="panel-heading">
            <h3 class="panel-title">{{ $t("message.usageSummary") }}
                <div class="pull-right" id="divAsOfDate" runat="server">
                    <label class="lbl-bold">{{ $t("message.asOf") }}&nbsp;</label><label class="lbl-bold lbl-nowrap" v-text="billingSummary.SummaryAsOfDate" />
                </div>
            </h3>
        </div>
        <div class="panel-body noform">
            <div id="divPrepay" v-if="billingSummary.ShowPrepayData">
                <table class="table table-lined">
                    <tbody>
                        <tr v-if="displayForDesktop">
                            <td class="td-alignmiddle">{{ $t("message.dollarsRemaining") }}</td>
                            <td class="td-right-align td-alignmiddle">
                                <label :style="{color: dollarsRemainingNegativeColor}">
                                    {{ handleNegativeNumber($n(billingSummary.BalanceSummaryData.DollarsRemaining , 'currency')) }}
                                </label> 
                            </td>
                        </tr>
                        <tr>
                            <td class="td-alignmiddle">{{ $t("message.deferredBalance") }}</td>
                            <td class="td-right-align td-alignmiddle">{{ billingSummary.DeferredBalance }}</td>
                        </tr>
                        <tr v-if="displayForDesktop">
                            <td class="td-alignmiddle">{{ $t("message.daysRemaining") }}</td>
                            <td class="td-right-align td-alignmiddle">{{ billingSummary.BalanceSummaryData.DaysRemaining }}</td>
                        </tr>
                        <tr>
                            <td class="td-alignmiddle">{{ $t("message.billingCycle") }}</td>
                            <td class="td-right-align td-alignmiddle">{{ billingSummary.BillingCycle }}</td>
                        </tr>
                        <tr>
                            <td class="td-alignmiddle">{{ $t("message.lastPayment") }}</td>
                            <td class="td-right-align td-alignmiddle">{{ billingSummary.LastPaymentForPrepay }}</td>
                        </tr>
                        <tr class="total">
                            <td class="td-alignmiddle">{{ $t("message.totalCharges") }}</td>
                            <td class="td-right-align td-alignmiddle">{{ billingSummary.TotalCharges }}</td>
                        </tr>
                        <tr v-if="billingSummary.ShowMinimumToReconnect" class="alert alert-danger">
                            <td colspan="2" class="td-alignmiddle lbl-bold" v-show="billingSummary.MinimumPaymentToReconnect !== ''">
                                {{ billingSummary.MinimumPaymentToReconnect }}
                            </td>
                            <td colspan="2" class="td-alignmiddle lbl-bold" v-show="billingSummary.MinimumPaymentToCancelDisconnect !== ''">
                                {{ billingSummary.MinimumPaymentToCancelDisconnect }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div id="divPostpay" v-else>
                <table class="table table-lined">
                    <tbody>
                        <tr>
                            <td class="td-alignmiddle">{{ $t("message.lastPayment") }}</td>
                            <td class="td-right-align td-alignmiddle">{{ billingSummary.LastPaymentForPostpay }}</td>
                        </tr>
                        <tr>
                            <td class="td-alignmiddle">{{ $t("message.billDate") }}</td>
                            <td class="td-right-align td-alignmiddle">{{ billingSummary.BillDate }}</td>
                        </tr>
                        <tr>
                            <td class="td-alignmiddle">{{ $t("message.billingPeriod") }}</td>
                            <td class="td-right-align td-alignmiddle">{{ billingSummary.BillingPeriod }}</td>
                        </tr>
                        <tr>
                            <td class="td-alignmiddle">{{ $t("message.daysInBillingPeriod") }}</td>
                            <td class="td-right-align td-alignmiddle">{{ billingSummary.DaysInBillingPeriod }}</td>
                        </tr>
                        <tr>
                            <td class="td-alignmiddle">{{ $t("message.totalAmountBilled") }}</td>
                            <td class="td-right-align td-alignmiddle">{{ billingSummary.TotalAmountBilled }}</td>
                        </tr>
                        <tr>
                            <td class="td-alignmiddle">{{ $t("message.pastDue") }}</td>
                            <td class="td-right-align td-alignmiddle">{{ billingSummary.PastDueAmount }}</td>
                        </tr>
                        <tr class="total">
                            <td class="td-alignmiddle">{{ billingSummary.TotalDueOrCreditText }}</td>
                            <td class="td-right-align td-alignmiddle">{{ billingSummary.TotalDue }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div id="divAutopayAlertMessage" class="alert alert-info" v-if="billingSummary.ShowAutopayAlert">
                <label class="lbl-bold" v-text="billingSummary.AutopayAlertText"></label>
            </div>

            <div class="tooltip-wrapper pull-right margin-left-bottom-5">
                <button class="btn btn-sm btn-success pull-right margin-left-bottom-5" v-if="billingSummary.ShowPayNowBtn"
                                @click.prevent="payNow()" aria-label="Pay Now">{{ billingSummary.PayNowText }}</button>
                <button class="btn btn-sm btn-primary pull-right margin-left-bottom-5" v-if="!billingSummary.ShowPrepayData" 
                                @click.prevent="viewBillHistory()" aria-label="View Bill History">{{ $t("message.billHistory") }}</button>
                <button class="btn btn-sm btn-primary pull-right margin-left-bottom-5" v-if="!billingSummary.ShowPrepayData" 
                                @click.prevent="viewCurrentBill()" aria-label="View Current Bill">{{ $t("message.currentBill") }}</button>                
            </div>            
        </div>
    </div>
</template>

<script>
import axios from "axios";
import commonJs from '@/common.js';

export default {
    name: 'BillingSummary',
    data() {
        return {
            billingSummaryLoaded: false
        }
    },
    methods: {
        viewBillHistory() { // Postpay

        },
        viewCurrentBill() { // Postpay

        },
        payNow() { // Prepay and Postpay
            this.$router.push({ name: "Payment" });
        },
        handleNegativeNumber(num) {
            return commonJs.reformatNumber(num);
        }
    },
    computed: {
        billingSummary() {
            // A call for fetching Billing Summary data has been added to AppLayout so we can update this information based on a timer
            // Response that we get back will be saved in our store (billingSummaryData object)
            // We have updated this call to execute only if 'DisplayCustomerInfoBox' is true OR client has access to Home navigation menu item
            this.billingSummaryLoaded = true;
            return this.$store.getters.getBillingSummaryData;
        },
        displayForDesktop() {
            return this.$store.getters.getIsDesktop;
        },
        dollarsRemainingNegativeColor() {
            var customerInfoFromStore = this.$store.getters.getCustomerInfo;
            return customerInfoFromStore.HeaderBalanceData.DollarsRemainingNegativeColor;
        }
    }
}
</script>

<style scoped>
.lbl-bold {
    font-weight: bold;
}

.lbl-nowrap {
    white-space: nowrap;
}

.td-right-align {
    text-align: right;
}

.td-alignmiddle {
    vertical-align: middle;
}
</style>